// JsFromRoutes CacheKey 14141904b51a8d76fd5eb2d80b91ef8a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  plans: /* #__PURE__ */ definePathHelper('get', '/billing/plans'),
  checkout: /* #__PURE__ */ definePathHelper('post', '/billing/checkout'),
  success: /* #__PURE__ */ definePathHelper('get', '/billing/success'),
  portal: /* #__PURE__ */ definePathHelper('get', '/billing/portal'),
}
